<script setup lang="ts">
import type { ComponentStyles } from 'types/index';

defineProps<{
  componentStyles?: ComponentStyles;
}>();
</script>

<template>
  <section
    class="component"
    :class="[
      componentStyles?.rowSpacingTop && componentStyles?.rowSpacingTop,
      componentStyles?.rowSpacingBottom && componentStyles?.rowSpacingBottom,
      componentStyles?.bgColor && componentStyles?.bgColor,
      componentStyles?.sectionPaddingTop && componentStyles?.sectionPaddingTop,
      componentStyles?.sectionPaddingBottom && componentStyles?.sectionPaddingBottom,
    ]"
  >
    <slot></slot>
  </section>
</template>
